import { render } from "./CommentsModal.vue?vue&type=template&id=63653be0&scoped=true&ts=true"
import script from "./CommentsModal.vue?vue&type=script&lang=ts"
export * from "./CommentsModal.vue?vue&type=script&lang=ts"

import "./CommentsModal.vue?vue&type=style&index=0&id=63653be0&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63653be0"]])

export default __exports__